import React, { useState, useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { FiArrowUp, FiArrowDown, FiInfo } from "react-icons/fi";
import Loader from "react-loader-spinner";
import { useTranslation } from "react-i18next";
import * as jobsActions from '../../Redux/Actions/jobs';
import * as commonActions from '../../Redux/Actions/common';
import { toastMessage } from '../../utils/toast';
import { useSortableData } from '../../utils/sortableData';
import { initiateLogOut } from '../../utils/initiate';
import { getParams, dateTimeFormat, useOnClickOutside } from '../../utils';
import Warning from '../Ui/400';
import ReactPaginate from 'react-paginate';
import DropDown from '../Ui/DropDown';
import DataCount from '../../utils/dataCount';
import { clearSession } from '../../utils/initiate';
import { reset, getJobStatus, getJobId, getFromDate, getToDate, getPassportNo, getDepartmentId, getMasterProcessId, getProcessId, getClearFilterFlag, getDepartmentList, getMasterProcessList, getProcessList } from '../../Redux/Reducers/jobFilter';

const JobsManagement = ({history}) => {
    const { jobStatusState, jobIdState, fromDateState, toDateState, passportNoState, departmentIdState, masterProcessIdState, 
        processIdState, clearFilterFlag, departmentList, masterProcessList, processList} = useSelector((state) => state.jobFilter);

    const [data, setData] = useState([]);
    const [statusList, setStatusList] = useState([]);
    const [errStatus, setErrStatus] = useState(200);
    const userData = useSelector(({User}) => User.data);
    const pageLoading = useSelector(({Common}) => Common.pageLoading);
    // const [jobSelectedStatus, setJobSelectedStatus] = useState('');
    // const [filterID, setFilterID] = useState('');
    // const [filterFromDate, setFilterFromDate] = useState('');
    // const [filterToDate, setFilterToDate] = useState('');
    const dispatch = useDispatch();
    let params = getParams(window.location.search);
    let groupStatus = params.groupStatus;
    let roload = (params.reload === 'true');
    const { t } = useTranslation();
    // const [filter, setFilter] = useState(0);
    // const [department, setDepartment] = useState('');
    // const [masterProcess, setMasterProcess] = useState('');
    // const [process, setProcess] = useState('');
    // const [departmentList, setDepartmentList] = useState([]);
    // const [masterProcessList, setMasterProcessList] = useState([]);
    // const [processList, setProcessList] = useState([]);

    let itemsPerPage = 10;
    const [currentItems, setCurrentItems] = useState([]);
    const [pageCount, setPageCount] = useState(0);
    const [itemOffset, setItemOffset] = useState(0);
    const [currentPage, setCurrentPage] = useState(() => parseInt(getParams(window.location.search).page) || 1);
    const [popupNoteID, setPopupNoteID] = useState('');
    const [isReadMore, setIsReadMore] = useState(true);
    const toggleReadMore = () => {setIsReadMore(!isReadMore);};
    const ref = useRef();
    const [loadingCsv, setLoadingCsv] = useState(false);

    useOnClickOutside(ref, () => handleNotePopupClose());

    useEffect(() => {
        handleGetAllJobs();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [clearFilterFlag]);

    useEffect(() => {
        handleGetJobStatuses();
        filterMapping();
        // handleGetAllDepartment();
        // handleGetAllMasterProcess();
        // handleGetAllProcess();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [roload, history]);

    const handleGetAllJobs = () => {
        dispatch(commonActions.pageLoading(true));
        let payload = {
            jobStatus: jobStatusState,
            groupStatus: groupStatus,
            jobID: jobIdState,
            passportNo: passportNoState,
            fromDate: fromDateState,
            toDate: toDateState,
            department: departmentIdState.value,
            masterProcess: masterProcessIdState.value,
            process: processIdState.value
        };
        jobsActions.getAllJobs(payload).then(res => {
            if(res && res.data){
                let jobData = [];
                res.data.map((form, index) => jobData.push({'sno': index+1, ...form, ...form.jobInfo}));
                setData(jobData);
            }else{
                setData([]);
                toastMessage('error', (res && res.message) || 'Unable to load the Jobs');
            }
            dispatch(commonActions.pageLoading(false));
        }).catch(err => {
            dispatch(commonActions.pageLoading(false));
            setErrStatus(err.response.status);
            (err.response.status === 401) && initiateLogOut(userData.UserId, dispatch, history);
        });
    };

    const handleGetJobStatuses = () => {
        jobsActions.getAllJobStatuses().then(({data}) => {
            if(data){
                setStatusList(data);
            }
        }).catch(err => {
            toastMessage('error', (err && err.message) || `Unable to get the job statuses`);
        });
    };

    const {items, requestSort, sortConfig} = useSortableData(data);


    useEffect(() => {
        const newPageCount = Math.ceil(items.length / itemsPerPage);
        setPageCount(newPageCount);
        if (currentPage > newPageCount && newPageCount > 0) {
                setCurrentPage(newPageCount);
                setItemOffset((newPageCount - 1) * itemsPerPage);
                const newParams = new URLSearchParams(window.location.search);
                newParams.set('page', newPageCount);
                history.replace({ search: newParams.toString() });
        }
    }, [items, itemsPerPage, currentPage, history]);

    useEffect(() => {
        setItemOffset((currentPage - 1) * itemsPerPage);
    }, [currentPage, itemsPerPage]);

    useEffect(() => {
        setCurrentItems(items.slice(itemOffset, itemOffset + itemsPerPage));
    }, [itemOffset, items, itemsPerPage]);

    const handlePageClick = (event) => {
        const newOffset = event.selected * itemsPerPage;
        setItemOffset(newOffset);
        setCurrentPage(event.selected + 1);
        const newParams = new URLSearchParams(window.location.search);
        newParams.set('page', event.selected + 1);
        history.replace({ search: newParams.toString() });
    };

    const handleNotePopupClose = () => {
        setPopupNoteID('');
        setIsReadMore(true);
    }


    // const handleGetAllDepartment = () => {
    //     jobsActions.getAllDepartments().then(({ data }) => {
    //         if (data) {
    //             let departmentList = data;
    //             departmentList = departmentList.map(({ id, name }) => ({ "label": name, "value": id }));
    //             setDepartmentList(departmentList);
    //         }
    //     }).catch(err => {
    //         toastMessage('error', (err && err.message) || `Unable to get the master process`);
    //     });
    // }

    // const handleGetAllMasterProcess = () => {
    //     jobsActions.getAllMasterProcesses().then(({ data }) => {
    //         if (data) {
    //             let masterProcessList = data;
    //             masterProcessList = masterProcessList.map(({ id, name }) => ({ "label": name, "value": id }));
    //             setMasterProcessList(masterProcessList);
    //         }
    //     }).catch(err => {
    //         toastMessage('error', (err && err.message) || `Unable to get the master process`);
    //     });
    // }

    // const handleGetAllProcess = () => {
    //     jobsActions.getAllProcesses().then(({ data }) => {
    //         if (data) {
    //             let processList = data;
    //             processList = processList.map(({ id, description }) => ({ "label": description, "value": id }));
    //             setProcessList(processList);
    //         }
    //     }).catch(err => {
    //         toastMessage('error', (err && err.message) || `Unable to get the process`);
    //     });
    // }

    const handleClearFilter = () => {
        dispatch(reset());
    }

    const filterHandler = () => {
        if(jobStatusState || jobIdState || passportNoState || fromDateState || toDateState || departmentIdState.value || processIdState.value || masterProcessIdState.value) {
            dispatch(getClearFilterFlag(clearFilterFlag + 1));
        } 
    };

    const filterMapping = () => {
        jobsActions.getAllServices().then((res) => {
            let departmentsList = res.data.departments;
            departmentsList = departmentsList.map(({name, id, masterProcess}) => ({"label": name, "value": id, "masterProcess": masterProcess}));
            departmentsList.unshift({label: "Select Department", "value": 0, "masterProcess": [] });
            dispatch(getDepartmentList(departmentsList));
        }).catch((err) => {
            setErrStatus(err?.response?.status);
            (err?.response?.status === 401) && clearSession(dispatch, history);
        })
    }

    const handleList = (key, ID) => {
        let list = [];
        if(key === 'department'){
            list = departmentList.filter(({value}) => value === ID)[0].masterProcess;
            list = list.map(({name, id, process}) => ({"label": name, "value": id, "process": process}));
            list.unshift({label: "Select Department", "value": 0, "process": [] });
            dispatch(getMasterProcessList(list));
        }else{
            list = masterProcessList.filter(({value}) => value === ID)[0].process;
            list = list.map(({name, id}) => ({"label": name, "value": id}));
            list.unshift({label: "Select Master process", "value": 0 });
            dispatch(getProcessList(list));
        }
    }

    function getAllComplaintsDownloadDatas() {
        setLoadingCsv(true);
        let payload = {
            jobStatus: jobStatusState,
            groupStatus: groupStatus,
            jobID: jobIdState,
            passportNo: passportNoState,
            fromDate: fromDateState,
            toDate: toDateState,
            department: departmentIdState.value,
            masterProcess: masterProcessIdState.value,
            process: processIdState.value
        };
        jobsActions.downLoadCsv(payload).then((res) => {
            try {
                toastMessage('info', `Download in progress`);
                var blob = new Blob(["\ufeff", res.data]);
                var link = document.createElement("a");
                link.href = window.URL.createObjectURL(blob);
                var fileName = 'TypingcenterJobs.csv';
                link.download = fileName;
                link.click();
            } catch (error) {
                console.log('err', error)
                toastMessage('error', "Something went wrong during file download!!");
            }
            setLoadingCsv(false);
        }).catch((err) => {
            setLoadingCsv(false);
            toastMessage('error', "Something went wrong during file download!!");
        })
    }

    if(errStatus === 400){
        return <Warning history={history} />;
    }

    return(
        <div className="container-fluid">
            <div className="page-title-box">
                <h4 className="page-title my-2">{t("jobsManagement.manageJobs.title")}</h4>            
            </div>
            <div className="row">
                <div className="col-lg-12 col-xxl-12">
                    <div className="card card-custom card-stretch gutter-b">
                        <div className="card-body p-3">
                            <div className="tab-content">
                                <div className="d-flex align-items-center justify-content-between mb-3">
                                    <div className="d-flex">
                                        <div className="me-3" style={{width:'100%'}}>
                                            <label className="mb-1 ms-1 me-3">{t("jobsManagement.filters.labelJobStatus")}</label>
                                            <select className="form-select me-3" value={jobStatusState} onChange={e => dispatch(getJobStatus(e.target.value))}>
                                                <option value="" disabled={true}>{t("reports.filters.selectJobStatus")}</option>
                                                {statusList.map(({lable, value}) =>
                                                    (value === 'Draft' || value === 'AwaitingPayment' || value === 'Pending' || value === 'AgentSelectionInProgress' || value === 'Payment'
                                                    ? null
                                                    : <option key={value} value={value}> {lable} </option>))}
                                            </select>
                                        </div>   
                                        <div className="me-3" style={{width:'100%'}}>
                                            <label className="mb-1 ms-1 me-3" style={{color: '#333'}}>{t("jobsManagement.filters.labelJobID")}</label>
                                            <input placeholder={t("jobsManagement.filters.enterID")} type="number" className="form-control me-3" name="Filter ID" value={jobIdState} onChange={e => dispatch(getJobId(e.target.value))}  />
                                        </div>
                                        <div className="me-3" style={{width:'100%'}}>
                                            <label className="mb-1 ms-1 me-3">{t("dashboard.awaitingResponseTable.passportNo")}</label>
                                            <input placeholder={t("dashboard.awaitingResponseTable.passportNo")} type="text" className="form-control me-3" name="passportNo" value={passportNoState} onChange={e => dispatch(getPassportNo(e.target.value))}  />
                                        </div>
                                        <div className="me-3" style={{width:'100%'}}>
                                            <label className="mb-1 ms-1 me-3">{t("jobsManagement.filters.LabelFromDate")}</label>
                                            <input type="date" className="form-control me-3" name="From Date" value={fromDateState} onChange={e => dispatch(getFromDate(e.target.value))}/>
                                        </div>
                                        <div className="me-3" style={{width:'100%'}}>
                                            <label className="mb-1 ms-1 me-3">{t("jobsManagement.filters.LabelToDate")}</label>
                                            <input type="date" disabled={fromDateState === '' ? true : false} min={fromDateState} className="form-control me-3" value={toDateState} onChange={e => dispatch(getToDate(e.target.value))} />
                                        </div>
                                     </div>
                                     <button className='btn btn-primary font-weight-bold d-flex align-items-center' disabled={loadingCsv} onClick={() => {getAllComplaintsDownloadDatas()}}>Export {(loadingCsv) && <Loader type="Oval" color="#fff" height={20} width={20} style={{marginLeft: '5px'}} />}</button>
                                </div>
                                <div className='d-flex align-items-center justify-content-between mb-3'>
                                    <div className='d-flex' style={{ width: '77.5%'}}>
                                        <div className="me-3" style={{ width: '20%' }}>
                                            <DropDown isSearchable={true} label={t("jobsManagement.filters.labelDepartment")} placeholder={t("jobsManagement.filters.selectDepartment")} options={departmentList} value={departmentIdState} onChange={value => {dispatch(getProcessList([])); handleList('department', value.value); dispatch(getDepartmentId(value)); }} />
                                        </div>
                                        <div className="me-3" style={{ width: '20%' }}>
                                            <DropDown isSearchable={true} label={t("jobsManagement.filters.labelMasterProcess")} placeholder={t("jobsManagement.filters.selectMasterProcess")} options={masterProcessList} value={masterProcessIdState} onChange={value => {handleList('masterProcess', value.value); dispatch(getMasterProcessId(value)); }} />
                                        </div>
                                        <div className="me-3" style={{ width: '20%' }}>
                                            <DropDown isSearchable={true} label={t("jobsManagement.filters.labelprocess")} placeholder={t("jobsManagement.filters.selectprocess")} options={processList} value={processIdState} onChange={value => {dispatch(getProcessId(value));}} />
                                        </div>
                                        <div className="d-flex align-items-end mb-3" style={{whiteSpace: 'nowrap'}}>
                                            <button onClick={filterHandler} type="button" className="d-flex me-3 px-4 align-items-center btn btn-primary font-weight-bold" >{t("jobsManagement.filters.filter")}</button>
                                        </div>
                                        <div className="d-flex align-items-end mb-3" style={{whiteSpace: 'nowrap'}}>
                                            <button onClick={e => handleClearFilter()}type="button" className="d-flex align-items-center btn btn-primary font-weight-bold" >{t("jobsManagement.filters.clearFilters")}</button>
                                        </div>
                                    </div>
                                </div>
                                {pageLoading ? <div className="d-flex align-items-center justify-content-center h-75vh"><Loader type="ThreeDots" color="#2d207d" height={40} width={40} style={{textAlign: 'center', marginBottom: '50px'}} /></div>
                                    : <div className="table-responsive">
                                    <table className="table table-head-custom table-vertical-center table-head-bg">
                                        <thead>
                                            <tr className="text-left">
                                                 {/* <th className="c-pointer pl-7" style={{width: '60px'}} onClick={() => requestSort('sno')}>
                                                    <span className={(sortConfig && (sortConfig.key === 'sno')) ? "text-secondary" : "text-dark-75"}>{t("jobsManagement.manageJobs.sNo")} {(sortConfig && (sortConfig.key === 'sno')) && ((sortConfig.direction === 'ascending') ? <FiArrowUp /> : <FiArrowDown />)}</span>
                                                </th>  */}
                                                <th className="c-pointer" style={{width: '75px'}} onClick={() => requestSort('jobId')}><span className={(sortConfig && (sortConfig.key === 'jobId')) ? "text-secondary" : "text-dark-75"}>{t("jobsManagement.manageJobs.id")} {(sortConfig && (sortConfig.key === 'jobId')) && ((sortConfig.direction === 'ascending') ? <FiArrowUp /> : <FiArrowDown />)}</span></th>
                                                <th className="c-pointer" style={{width: '150px'}} onClick={() => requestSort('date')}><span className={(sortConfig && (sortConfig.key === 'date')) ? "text-secondary" : "text-dark-75"}>{t("jobsManagement.manageJobs.dateTime")} {(sortConfig && (sortConfig.key === 'date')) && ((sortConfig.direction === 'ascending') ? <FiArrowUp /> : <FiArrowDown />)}</span></th>
                                                <th className="c-pointer" style={{width: '150px'}} onClick={() => requestSort('customerInfo')}><span className={(sortConfig && (sortConfig.key === 'customerInfo')) ? "text-secondary" : "text-dark-75"}>{t("jobsManagement.manageJobs.user")} {(sortConfig && (sortConfig.key === 'customerInfo')) && ((sortConfig.direction === 'ascending') ? <FiArrowUp /> : <FiArrowDown />)}</span></th>
                                                <th className="c-pointer" style={{width: '150px'}} onClick={() => requestSort('passportNo')}><span className={(sortConfig && (sortConfig.key === 'passportNo')) ? "text-secondary" : "text-dark-75"}>{t("dashboard.awaitingResponseTable.passportNo")} {(sortConfig && (sortConfig.key === 'passportNo')) && ((sortConfig.direction === 'ascending') ? <FiArrowUp /> : <FiArrowDown />)}</span></th>
                                                <th className="c-pointer" style={{width: '150px'}} onClick={() => requestSort('referenceName')}><span className={(sortConfig && (sortConfig.key === 'referenceName')) ? "text-secondary" : "text-dark-75"}>{t("jobsManagement.manageJobs.referenceName")} {(sortConfig && (sortConfig.key === 'referenceName')) && ((sortConfig.direction === 'ascending') ? <FiArrowUp /> : <FiArrowDown />)}</span></th>
                                                <th className="c-pointer" style={{width: '150px'}} onClick={() => requestSort('departmentName')}><span className={(sortConfig && (sortConfig.key === 'departmentName')) ? "text-secondary" : "text-dark-75"}>{t("jobsManagement.manageJobs.department")} {(sortConfig && (sortConfig.key === 'departmentName')) && ((sortConfig.direction === 'ascending') ? <FiArrowUp /> : <FiArrowDown />)}</span></th>
                                                <th className="c-pointer" style={{width: '200px'}} onClick={() => requestSort('masterProcessName')}><span className={(sortConfig && (sortConfig.key === 'masterProcessName')) ? "text-secondary" : "text-dark-75"}>{t("jobsManagement.manageJobs.masterProcess")} {(sortConfig && (sortConfig.key === 'masterProcessName')) && ((sortConfig.direction === 'ascending') ? <FiArrowUp /> : <FiArrowDown />)}</span></th>
                                                <th className="c-pointer" style={{minWidth: '200px'}} onClick={() => requestSort('processName')}><span className={(sortConfig && (sortConfig.key === 'processName')) ? "text-secondary" : "text-dark-75"}>{t("jobsManagement.manageJobs.process")} {(sortConfig && (sortConfig.key === 'process')) && ((sortConfig.direction === 'ascending') ? <FiArrowUp /> : <FiArrowDown />)}</span></th>
                                                <th className="c-pointer" style={{minWidth: '100px'}} onClick={() => requestSort('staffInfo')}><span className={(sortConfig && (sortConfig.key === 'staffInfo')) ? "text-secondary" : "text-dark-75"}>{t("jobsManagement.manageJobs.staff")} {(sortConfig && (sortConfig.key === 'staffInfo')) && ((sortConfig.direction === 'ascending') ? <FiArrowUp /> : <FiArrowDown />)}</span></th>
                                                <th style={{minWidth: '100px'}}><span className="text-dark-75">{t("jobsManagement.manageJobs.status")}</span></th>
                                                <th style={{minWidth: '100px', }}><span className="text-dark-75">{t("jobsManagement.manageJobs.action")}</span></th>
                                                <th className="c-pointer" style={{width: '60px', position: 'sticky', zIndex: '10', right: '0'}}>{t("jobsManagement.manageJobs.sNo")}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {currentItems.map(({sno, customerInfo, passportNo, acceptedDate, departmentName, masterProcessName, processName, staffInfo, jobId, status, jobNotes, referenceName }) => {
                                                let statusClass  = (status.toLowerCase() === 'completed') ? 'success' : ((status.toLowerCase() === 'cancelled') ? 'danger' : 'purple');
                                                return(
                                                    <tr key={sno} style={{ backgroundColor: jobNotes.length > 0 ? '#e3f2fd' : 'inherit' }}>
                                                        {/* <td className="pl-7">
                                                            <span className="text-dark-75 font-weight-bolder d-block font-size-lg">{sno}</span>
                                                        </td> */}
                                                        <td>
                                                            <span className="text-dark-75 font-weight-bolder d-block font-size-lg">{jobId}</span>
                                                        </td>
                                                        <td>
                                                            <span className="text-dark-75 font-weight-bolder d-block font-size-lg">{acceptedDate}</span>
                                                        </td>
                                                        <td>
                                                            <span className="text-dark-75 font-weight-bolder d-block font-size-lg">{customerInfo}</span>
                                                        </td>
                                                        <td>
                                                            <span className="text-dark-75 font-weight-bolder d-block font-size-lg">{passportNo ? passportNo : '-'}</span>
                                                        </td>
                                                        <td>
                                                            <span className="text-dark-75 font-weight-bolder d-block font-size-lg">{referenceName ? referenceName : '-'}</span>
                                                        </td>
                                                        <td className="pl-0 py-8">
                                                            <span className="text-dark-75 font-weight-bolder d-block font-size-lg">{departmentName}</span>
                                                        </td>
                                                        <td>
                                                            <span className="text-dark-75 font-weight-bolder d-block font-size-lg">{masterProcessName}</span>
                                                        </td>
                                                        <td>
                                                            <span className="text-dark-75 font-weight-bolder d-block font-size-lg">{processName}</span>
                                                        </td>
                                                        <td>
                                                            <span className="text-dark-75 font-weight-bolder d-block font-size-lg">{staffInfo}</span>
                                                        </td>
                                                        <td style={{whiteSpace: 'nowrap'}}>
                                                            <span className={"p-2 badge badge-outline-" + statusClass} style={{borderRadius: '3px', width: 'auto'}}>{status}</span>
                                                        </td>
                                                        <td className="pr-0">
                                                            <button disabled={status.toLowerCase() === 'completed' || status.toLowerCase() === 'cancelled'} onClick={() => history.push(`/jobs/${jobId}`)} className="btn btn-info font-weight-bolder font-size-sm mr-3">{t("jobsManagement.manageJobs.more")}</button>
                                                            {jobNotes.length === 0 
                                                               ? null
                                                               :<FiInfo className="c-pointer font-20 ms-lg-2" onClick={() => setPopupNoteID(jobId)}/>}
                                                            {
                                                               jobNotes.length === 0 
                                                               ? null
                                                               : <div> 
                                                                   <div className="position-relative ms-2">
                                                                   {(popupNoteID === jobId) && 
                                                                       <div ref={ref} className="popover position-absolute fade show bs-popover-start" style={{width: '300px', left: '-300px', top:'-70px'}}>
                                                                           <div className="m-0 p-3 popover-body" style={{maxHeight:'200px', overflow:'auto'}}>
                                                                               {
                                                                                   jobNotes.map(({id, createdTime, note, createdBy}) => {
                                                                                    return(
                                                                                        <div key={id}>
                                                                                             <div className="form-group fv-plugins-icon-container" style={{marginBottom: '0px', paddingBottom: '5px'}}>
                                                                                                 {jobNotes && <span className="text-muted">{t("Date")} : </span>} {dateTimeFormat(createdTime)}
                                                                                             </div>
                                                                                             <div className="form-group fv-plugins-icon-container" style={{marginBottom: '0px', paddingBottom: '5px'}}>
                                                                                                 {jobNotes && <span className="text-muted">{t("Note")} : </span>} { note? isReadMore ? note.slice(0, 100) : note : '-' }
                                                                                                 {
                                                                                                     note && note.length > 150 
                                                                                                     ? <span onClick={toggleReadMore} style={{cursor:'pointer',color:'#0f8bc9'}}> {isReadMore ? "...show more" : "...show less"}</span>
                                                                                                     : null
                                                                                                 }
                                                                                             </div>
                                                                                             <div className="form-group fv-plugins-icon-container" style={{marginBottom: '10px', paddingBottom: '5px', borderBottom: '1px solid #f1f5fa'}}>
                                                                                                 {jobNotes && <span className="text-muted">{t("Created By")} : </span>} {createdBy}
                                                                                             </div>
                                                                                         </div>
                                                                                     )
                                                                                   })
                                                                               }
                                                                           </div>
                                                                        </div>}
                                                                    </div>
                                                                </div>
                                                            }
                                                        </td>
                                                        <td className="pr-0">
                                                            <span className="text-dark-75 font-weight-bolder d-block font-size-lg">{sno}</span>
                                                        </td>
                                                    </tr>
                                                )})}
                                        </tbody>
                                    </table>
                                    {(pageCount > 1) && <ReactPaginate
                                        breakLabel="..."
                                        nextLabel=">"
                                        previousLabel="<"
                                        onPageChange={handlePageClick}
                                        pageRangeDisplayed={5}
                                        pageCount={pageCount}
                                        forcePage={currentPage - 1}
                                        pageClassName="page-item"
                                        pageLinkClassName="page-link"
                                        previousClassName="page-item"
                                        previousLinkClassName="page-link"
                                        nextClassName="page-item"
                                        nextLinkClassName="page-link"
                                        breakClassName="page-item"
                                        breakLinkClassName="page-link"
                                        containerClassName="pagination"
                                        activeClassName="active"
                                        renderOnZeroPageCount={null}
                                    />}
                                    {(data.length === 0) && <p className="text-center mt-5 mb-5">{t("jobsManagement.noDataAvailable")}</p>}
                                </div>}
                                {data.length>0 && <DataCount itemOffset={itemOffset} items={items}/>}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default JobsManagement;